import React from 'react';
import PropTypes from 'prop-types';
import LandingMediaKitProposal from '../TNOMediaKitProposal';

/** Media kit de programa desde propuesta estática (grilla / ProgramProposalLayout). */
const LandingMediaKitProgramStatic = ({ forcedSlug = '', ...props }) => (
  <LandingMediaKitProposal {...props} staticOnly forcedSlug={forcedSlug} />
);

LandingMediaKitProgramStatic.propTypes = {
  forcedSlug: PropTypes.string,
  themeMode: PropTypes.string,
};

export default LandingMediaKitProgramStatic;
